<template>
	<div>
		<ModalDetailTransaction ref="ModalDetailTransaction"></ModalDetailTransaction>
		<modalSendEmailSerial ref="modalSendEmailSerial" @action="sendEmail"></modalSendEmailSerial>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Transaksi Ecommerce</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listData" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationData.total_data" class="table-w-150">
				<template v-slot:item.action="{ item }">
					<div class="pt-2 pb-2">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.trx_id)" class="mr-2">
									<v-icon dark>mdi-text-box-search</v-icon>
								</v-btn>
							</template>
							<span>Detail</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn fab dark x-small depressed color="primary" v-bind="attrs" v-on="on" @click.stop="showSendEmailModal(item.trx_id, item.trx_buyer_email)" class="mr-2">
									<v-icon dark>mdi-email-send-outline</v-icon>
								</v-btn>
							</template>
							<span>Email Serial</span>
						</v-tooltip>
					</div>
				</template>
				<template v-slot:item.trx_code="{ item }">
					<div class="pt-2">{{ item.trx_code }}</div>
				</template>
				<template v-slot:item.trx_datetime="{ item }">
					<div class="pt-2">{{ item.trx_datetime | tanggaljam}}</div>
				</template>
				<template v-slot:item.trx_buyer_name="{ item }">
					<div class="pt-2">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<span v-bind="attrs" v-on="on">
									{{ maxLength(item.trx_buyer_name, 15) }}
									<span v-if="item.member_network_mid"> ({{item.member_network_mid}})</span>
								</span>
							</template>
							<span>
								{{ item.trx_buyer_name }}
								<span v-if="item.member_network_mid"> ({{item.member_network_mid}})</span>
							</span>
						</v-tooltip>
					</div>
				</template>
				<template v-slot:item.stockist_code="{ item }">
					<div class="pt-2">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<span v-bind="attrs" v-on="on">
									{{ maxLength(item.stockist_name, 15) }}
									<span v-if="item.member_network_mid"> ({{item.stockist_code}})</span>
								</span>
							</template>
							<span>
								{{ item.stockist_name }}
								<span v-if="item.stockist_code"> ({{item.stockist_code}})</span>
							</span>
						</v-tooltip>
					</div>
				</template>
				<template v-slot:item.trx_status_name="{ item }">
					<div class="pt-2">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<span v-bind="attrs" v-on="on">{{ maxLength(item.trx_status_name, 25) }}</span>
							</template>
							<span>{{ item.trx_status_name }}</span>
						</v-tooltip>
					</div>
				</template>
				<template v-slot:item.trx_price_grand_total="{ item }">
					<div class="pt-2">{{ item.trx_price_grand_total | toRupiah }}</div>
				</template>
				<template v-slot:item.trx_shipping_method="{ item }">
					<div class="pt-2">{{ item.trx_shipping_method == 1 ? 'Shipping Courier' : 'Pickup' }}</div>
				</template>
				<template v-slot:item.trx_payment_method_text="{ item }">
					<div class="pt-2">{{ item.trx_payment_method_text }}</div>
				</template>
				<template v-slot:item.trx_platform="{ item }">
					<div class="pt-2">{{ item.trx_platform }}</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationData">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationData">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationData.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationData.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalDetailTransaction from './components/ModalDetailTransaction'
import modalSendEmailSerial from './components/ModalSendEmailSerial'

const listShipping = [{
	value: '0',
	text: 'Pickup'
}, {
	value: '1',
	text: 'Shipping Courier'
}];

const listPayment = [{
	value: '0',
	text: 'Bonus',
}, {
	value: '1',
	text: 'Bank Transfer',
}, {
	value: '2',
	text: 'Virtual Account',
}, {
	value: '3',
	text: 'Cash',
}]

const listPlatform = ['pos', 'ecommerce'];

export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalDetailTransaction, modalSendEmailSerial
	},
	data() {
		return {
			sortBy: 'trx_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', align: 'center', value: 'action', sortable: false },
			{ text: 'Kode Transaksi', align: 'start', value: 'trx_code'},
			{ text: 'Tanggal Transaksi', align: 'start', value: 'trx_datetime'},
			{ text: 'Member', value: 'trx_buyer_name', sortable: false },
			{ text: 'Stockist', value: 'stockist_code', sortable: false },
			{ text: 'Status', value: 'trx_status_name', sortable: false, width: '' },
			{ text: 'Total Transaksi', value: 'trx_price_grand_total'},
			{ text: 'Jenis Pengambilan', value: 'trx_shipping_method'},
			{ text: 'Metode Pembayaran', value: 'trx_payment_method_text'},
			{ text: 'Platform', value: 'trx_platform' },
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Transaksi',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'trx_code'
				}
			}, {
				type: 'date',
				show: false,
				label: 'Tanggal Transaksi',
				filter: {
					value: [],
					comparison: 'bet',
					type: 'date',
					field: 'trx_datetime'
				}
			}, {
				type: 'selection',
				label: 'Platform',
				item: listPlatform,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'trx_platform'
				}
			}, {
				type: 'text',
				label: 'Nama Pembeli',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'trx_buyer_name'
				}
			}, {
				type: 'text',
				label: 'Kode Mitra',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'member_network_mid'
				}
			}, {
				type: 'selection',
				label: 'Status Transaksi',
				item: [],
				itemValue: 'code',
				itemText: 'name',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'trx_status'
				}
			}, {
				type: 'text',
				label: 'Nama Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_name'
				}
			}, {
				type: 'text',
				label: 'Kode Stockist',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'stockist_code'
				}
			}, {
				type: 'selection',
				label: 'Jenis Pengambilan',
				item: listShipping,
				itemValue: 'value',
				itemText: 'text',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'trx_shipping_method'
				}
			}, {
				type: 'selection',
				label: 'Metode Pembayaran',
				item: listPayment,
				itemValue: 'value',
				itemText: 'text',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'trx_payment_method'
				}
			},
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceTransaction', ['listData', 'paginationData', 'listStatus']),
	},
	methods: {
		...mapActions('ecommerceTransaction', ['getTransaction', 'exportTransaction', 'getDetailTransaction', 'getStatusListTransaction', 'sendEmailSerial']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceTransaction', ['clearDataTransaction']),

		maxLength(val, max) {
			let text = val
			if (text.length > max)
				text = text.slice(0,max) + '...'
			return text
		},
		getData() {
			this.getTransaction(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportTransaction(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		async getDetail(trx_id) {
			await this.getDetailTransaction({
				trx_id: trx_id
			})
			await this.$refs.ModalDetailTransaction.showModal()
		},
		showSendEmailModal(trx_id, email) {
			this.$refs.modalSendEmailSerial.showModal(trx_id, email)
		},
		async sendEmail(params) {
			let result = await this.sendEmailSerial(params)
			if (result == true)
				await this.$refs.modalSendEmailSerial.hideModal()
		}
	},
	beforeDestroy(){
		this.clearDataTransaction()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Transaction Ecommerce`)
		await this.getData()
		let indexStatus = await this.filterData.findIndex(el => el.label == 'Status Transaksi')
		this.filterData[indexStatus].item = await this.getStatusListTransaction()

		await this.setFilter(this.filterData)
	},
};
</script>